module.exports = __webpack_public_path__ + "static/media/menu.a1f2c29c.svg";